import React, { useEffect, useRef } from 'react';
import { parseMarkdown, setupCodeBlockCopyButtons, setupExternalLinkHandlers, renderMath } from '../../../../../core';
import './DownloadDetailsView.css';

export function DownloadDetailsView({ download }) {
  const descriptionMarkdownRef = useRef(null);

  useEffect(() => {
    if (!download || !descriptionMarkdownRef.current) return;
    const content = (download.description || '').trim();
    if (!content) {
      descriptionMarkdownRef.current.innerHTML = '';
      return;
    }
    const parsedHtml = parseMarkdown(content);
    descriptionMarkdownRef.current.innerHTML = parsedHtml;
    setupCodeBlockCopyButtons(descriptionMarkdownRef.current);
    setupExternalLinkHandlers(descriptionMarkdownRef.current);
    renderMath(descriptionMarkdownRef.current);
  }, [download]);

  if (!download) return null;

  const views = download.views ?? 0;
  const downloadCount = download.downloads ?? 0;
  const createdAt = download.createdAt
    ? new Date(download.createdAt).toLocaleDateString(undefined, {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      })
    : '';

  return (
    <div className="download-details-view">
      <h1 className="download-details-title">{download.title || 'Untitled Download'}</h1>

      <div className="download-details-meta">
        <span className="download-details-meta-item">
          <i className="fa-solid fa-eye"></i> {views} views
        </span>
        <span className="download-details-meta-item">
          <i className="fa-solid fa-download"></i> {downloadCount} downloads
        </span>
        {createdAt && (
          <span className="download-details-meta-item">
            <i className="fa-solid fa-calendar"></i> {createdAt}
          </span>
        )}
      </div>

      {/* Tags Row */}
      {Array.isArray(download.tags) && download.tags.length > 0 && (
        <div className="download-details-tags-row">
          {download.tags.map((tag, index) => (
            <span key={index} className="download-details-tag">
              {tag.charAt(0).toUpperCase() + tag.slice(1)}
            </span>
          ))}
        </div>
      )}

      <div className="download-details-description-section">
        <h3 className="download-details-description-label">Description</h3>
        {download.description?.trim() ? (
          <div
            ref={descriptionMarkdownRef}
            className="download-details-description download-details-description-markdown"
          />
        ) : (
          <p className="download-details-description download-details-description--empty">
            No description available.
          </p>
        )}
      </div>
    </div>
  );
}
